const initVoucher = {
  vouchers: [],
  voucherCategories: [],
  currentPage: 1,
  totalPage: 1,
  limitPage: 10,
  lengthPage: 1,
  searchValue: "",
  filterTenantPage: "",
  isFormLoading: false,
};

export const voucherReducer = (state = initVoucher, action: any) => {
  if (action.type === "SET_VOUCHER") {
    return {
      ...state,
      vouchers: action.value,
    };
  }
  if (action.type === "SET_VOUCHER_CATEGORY") {
    return {
      ...state,
      voucherCategories: [{ category: "all" }, ...action.value],
    };
  }
  if (action.type === "SET_VOUCHER_CURRENT_PAGE") {
    return {
      ...state,
      currentPage: action.currentPage,
    };
  }
  if (action.type === "SET_VOUCHER_PAGE") {
    return {
      ...state,
      totalPage: action.totalPage,
      limitPage: action.limitPage,
      lengthPage: action.lengthPage,
    };
  }
  if (action.type === "SET_SEARCH_VOUCHER") {
    return {
      ...state,
      searchValue: action.searchValue,
    };
  }
  if (action.type === "SET_VOUCHER_FILTER_PAGE") {
    return {
      ...state,
      filterTenantPage: action.filterTenantPage,
    };
  }
  if (action.type === "SET_FORM_LOADING") {
    return {
      ...state,
      isFormLoading: action.value,
    };
  }
  return state;
};
